"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledProgressStepperStep = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ProgressStepperStepMixin = require("../../mixins/components/ProgressStepperStepMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var _UnstyledButton = require("../UnstyledButton/UnstyledButton");
var StyledProgressStepperStep = /*#__PURE__*/(0, _styledComponents.default)(_UnstyledButton.UnstyledButton).withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['orientation'])
}).withConfig({
  displayName: "StyledProgressStepperStep",
  componentId: "c11n-8-107-0__sc-mb634v-0"
})(["", ""], _ProgressStepperStepMixin.ProgressStepperStepMixin);
exports.StyledProgressStepperStep = StyledProgressStepperStep;